import React, { Component } from 'react'

import { CrfContext } from '../../CrfContext'

import SideNav from '../sidenav/Sidenav'
import { Link } from 'react-router-dom'

import './ForEndorsement.css'

import axios from 'axios'
import ForEndorsementModal from './ForEndorsementModal'
import ToInProcessModal from './ToInProcessModal'

export class ForEndorsement extends Component {
  state = {
    approvedRequest: false,
    allRequests: [],
    allCrf: [],
    crfToUpdate: [],
    onholdMessage: 'This request has been marked as On Hold',
    status: '',
    grandTotal: '0.00'
  }

  componentDidMount() {
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/status/forEndorsement`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        const data = response.data.data
        let crfs = []

        // const data = response.data.data
        // let crfs = []
        for (let i = 0; i < data.length; i++) {
            
          crfs.push(data[i]._id)
        }
        let totalNetPrice = 0
        for (const obj of response.data.data) {
          totalNetPrice =
            parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice)
        }
        this.setState({
          allRequests: response.data.data,
          allCrf: crfs,
          grandTotal: totalNetPrice.toFixed(2)
        })

        //     
      })
      .catch(error => {
          
      })
  }

  handleInprocess = e => {
    e.preventDefault()
      
    axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/inProcess/${this.props.match.params.id}`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
          
        window.location.reload()
      })
      .catch(error => {
          
      })
  }

  selectAllCrf = () => {
    document.getElementById('selectAllForEndorsement').style.display = 'none'
    document.getElementById('unSelectAllForEndorsement').style.display = 'block'
      
    const allCrf = []
    for (let i = 0; i < this.state.allCrf.length; i++) {
      allCrf.push(this.state.allCrf[i])
    }
    this.setState({
      crfToUpdate: allCrf
    })
    const checkBoxes = document.getElementsByClassName('checkEndorsementBtn')
    for (let i = 0; i < checkBoxes.length; i++) {
      document.getElementsByClassName('checkEndorsementBtn')[
        i
      ].children[0].style.color = 'red'
    }
  }

  unSelectAllCrf = () => {
    document.getElementById('selectAllForEndorsement').style.display = 'block'
    document.getElementById('unSelectAllForEndorsement').style.display = 'none'
      
    this.setState({
      crfToUpdate: []
    })
    // const checkBoxes = document.getElementsByClassName('checkEndorsementBtn')
    // for (let i = 0; i < checkBoxes.length; i++) {
    //     document.getElementsByClassName('checkEndorsementBtn')[i].style.color = "rgb(182, 176, 176)"
    // }
    const checkBoxes = document.getElementsByClassName('checkEndorsementBtn')
    for (let i = 0; i < checkBoxes.length; i++) {
      document.getElementsByClassName('checkEndorsementBtn')[
        i
      ].children[0].style.color = 'rgb(182, 176, 176)'
    }
  }

  toggleCrfSelect = e => {
      

    if (!this.state.crfToUpdate.includes(e.target.id)) {
      this.state.crfToUpdate.push(e.target.id)
        
      e.target.style.color = 'red'
    } else {
      if (this.state.crfToUpdate.indexOf(e.target.id) === 0) {
        this.state.crfToUpdate.shift()
        e.target.style.color = 'rgb(182, 176, 176)'
      } else {
        e.target.style.color = 'rgb(182, 176, 176)'
        this.state.crfToUpdate.splice(
          this.state.crfToUpdate.indexOf(e.target.id),
          1
        )
      }
        
    }
  }

  handleUpdateMultiple = () => {
      
    for (let i = 0; i < this.state.crfToUpdate.length; i++) {
      //   
      axios({
        method: 'PUT',
        url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/inProcess/${this.state.crfToUpdate[i]}`,
        headers: {
          'Api-Key':
            '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
      })
        .then(response => {
            
          window.location.reload()
        })
        .catch(error => {
            
        })
    }
  }

  handleMultipleOnHold = e => {
    // e.preventDefault()
    for (let i = 0; i < this.state.crfToUpdate.length; i++) {
      axios({
        method: 'PUT',
        url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/onHold/${this.state.crfToUpdate[i]}`,
        data: {
          reason: this.state.onholdMessage
        },
        headers: {
          'Api-Key':
            '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
      })
        .then(response => {
            
          if (response.data.data.nModified === 1) {
            window.location.reload()
          }
        })
        .catch(error => {
            
        })
    }
  }

  handleOnHoldMessage = e => {
    this.setState({
      onholdMessage: e.target.value
    })
  }

  handleShowModal = e => {
    this.setState({
      status: e.target.name
    })
    document.getElementById('modalBody').style.display = 'block'
  }

  handleCloseModal = () => {
    document.getElementById('modalBody').style.display = 'none'
  }

  formatDate = date => {
    const dateArray = date.split('-')
    let month = dateArray[1]
    const day = dateArray[2].substring(0, 2)
    const year = dateArray[0]
    switch (dateArray[1]) {
      case '02':
        month = 'Feb'
        break
      case '03':
        month = 'Mar'
        break
      case '04':
        month = 'Apr'
        break
      case '05':
        month = 'May'
        break
      case '06':
        month = 'Jun'
        break
      case '07':
        month = 'Jul'
        break
      case '08':
        month = 'Aug'
        break
      case '09':
        month = 'Sep'
        break
      case '10':
        month = 'Oct'
        break
      case '11':
        month = 'Nov'
        break
      case '12':
        month = 'Dec'
        break
      default:
        month = 'Jan'
    }
    return `${month} ${day}, ${year}`
  }
  addCommas(nStr) {
    nStr += ''
    var x = nStr.split('.')
    var x1 = x[0]
    var x2 = x.length > 1 ? '.' + x[1] : ''
    var rgx = /(\d+)(\d{3})/
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2')
    }
    return x1 + x2
  }

  render() {
      
    const allRequests = this.state.allRequests

    return (
      <CrfContext.Consumer>
        {context => (
          <div id='mainPage'>
            <div id='sidePanel'>
              <ForEndorsementModal
                crfToUpdate={this.state.crfToUpdate}
                handleCloseModal={this.handleCloseModal}
                status={this.state.status}
              />
              <SideNav
                testState={context.state.testState}
                toggleBtn1List={context.toggleBtn1List}
                toggleBtn2List={context.toggleBtn2List}
                btn1List={context.state.btn1List}
                btn2List={context.state.btn2List}
                userRole={context.state.userRole}
              />
            </div>
            <div id='mainPanel'>
              <div className='requestSelectionPanel'>
                <div className='toApproveHeader'>
                  <div className='UpdateSeletedForEndorsement'>
                    <h1 className='UpdateSeletedForEndorsementContent1'>
                      For Endorsement
                    </h1>
                    <h5 className='updateSelectedLabel'>Update Selected:</h5>
                    <div className='UpdateSeletedForEndorsementContent2'>
                      <button
                        className='UpdateSelected'
                        name='In Process'
                        id='multipleInProcessButton'
                        onClick={this.handleShowModal}
                      >
                        In Process
                      </button>
                      <button
                        className='UpdateSelected'
                        name='On Hold'
                        id='multipleOnholdButton'
                        onClick={this.handleShowModal}
                      >
                        On Hold
                      </button>
                    </div>
                  </div>
                  {/* TABLE HEAD */}

                  <div className='myRequestTableHeader'>
                    <small class='numHead'>0</small>

                    <div className='tHeadBtn'>
                      <span
                        onClick={this.selectAllCrf}
                        id='selectAllForEndorsement'
                      >
                        <i class='fas fa-check-square' title='Select all'></i>
                      </span>
                      <span
                        onClick={this.unSelectAllCrf}
                        id='unSelectAllForEndorsement'
                      >
                        <i
                          class='fas fa-check-square'
                          title='Un Select All'
                        ></i>
                      </span>
                    </div>
                    {/* <div className='tHeadCrfNo'>
                      <h4>CRF#</h4>
                    </div> */}
                    <div className='tHead'>CRF#</div>
                    <div className='tHead'>Date Created</div>
                    {this.state.toggleReleased ? (
                      <div className='tHead'>Date Released</div>
                    ) : (
                      <div className='tHeadExp'>Expected Completion Date</div>
                    )}
                    <div className='tHead'>Due date</div>
                    <div className='tHead'>Vendor</div>
                    <div className='tHead'>Amount Requested</div>
                    <div className='tHead'>Project</div>
                    <div className='tHead'>Department</div>
                    <div className='tHead'>Status</div>
                    <div className='tHead'>Request Type</div>
                  </div>
                  {/*END TABLE HEAD */}
                </div>
              </div>
              {/* TABLE DATA */}
              <div className='divisionToApprove'></div>
              {allRequests.map(
                (requestsArray, index) => (
                  // <Link style={link} to={`/CheckRequest/${requestsArray._id}`}>
                  <div className='tableData' style={{ height: '60px' }}>
                    <div className='tdataBtn1'>
                      <Link
                        to={`/CheckRequest/${requestsArray._id}`}
                        style={colorRed}
                      >
                        <i class='fas fa-eye'></i>
                      </Link>
                    </div>
                    <div className='tdataBtn'>
                      <span
                        className='checkEndorsementBtn'
                        onClickCapture={this.toggleCrfSelect}
                      >
                        <i
                          id={requestsArray._id}
                          class='fas fa-check-square'
                        ></i>
                      </span>
                    </div>
                    <div className='tData'>
                      <h4>{requestsArray.crfNo}</h4>
                    </div>
                    <div className='tData'>
                      <h4>{requestsArray.creationDate.slice(4, 21)}</h4>
                    </div>
                    <div className='tData'>
                      <h4 className=''>
                        {requestsArray.expectedCompletionDate
                          ? requestsArray.expectedCompletionDate.slice(4, 21)
                          : '--'}
                      </h4>
                    </div>
                    <div className='tData'>
                      <h4>{this.formatDate(requestsArray.dueDate)}</h4>
                    </div>
                    <div className='tData2'>
                      <h4>{requestsArray.vendor.bpName}</h4>
                    </div>
                    <div className='tData'>
                      <h4>
                        <span>&#8369;</span>
                        {requestsArray.totalNetPrice
                          .toFixed(2)
                          .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                      </h4>
                    </div>
                    <div className='tData'>
                      <h4>{requestsArray.project.projectName}</h4>
                    </div>
                    <div className='tData'>
                      <h4>{requestsArray.department.centerName}</h4>
                    </div>
                    <div className='tData'>
                      <h4>{requestsArray.status}</h4>
                    </div>
                    <div className='tData'>
                      <h4>{requestsArray.requestType}</h4>
                    </div>
                  </div>
                )
                // </Link>
              )}
              <br />
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                  paddingRight: '3rem'
                }}
              >
                <div style={{ flexBasis: '20%' }}>
                  <p style={{ textAlign: 'right' }}>Total Amount:</p>
                </div>
                <div style={{ flexBasis: '30%' }}>
                  <p style={{ textAlign: 'right' }}>
                    &#8369; {this.addCommas(this.state.grandTotal)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </CrfContext.Consumer>
    )
  }
}

const colorRed = {
  color: 'red'
}

const link = {
  textDecoration: 'none',
  color: 'black'
}

export default ForEndorsement
